import React from "react";
import {
  AUDIENCE_CHIP_CLASS,
  RESTRICTED_CHIP_CLASS,
  audienceChipLabel,
  audienceChipTitle,
  initials,
  isRestrictedAudience,
  timeAgo,
} from "./constants";

const PostHeader = ({ post, badgeClass, badgeLabel, title, avatarText }) => {
  // A poll's group limits who can see it; on every other type it is just a tag.
  const restricted = isRestrictedAudience(post.type);

  return (
  <div className="flex items-start gap-3 px-4 pt-4">
    <span className="flex h-9 w-9 flex-none items-center justify-center rounded-full border-2 border-green-500 bg-white text-xs font-semibold text-gray-700">
      {avatarText || initials(post.authorName)}
    </span>

    <div className="min-w-0 flex-1">
      <p className="truncate text-sm font-semibold text-gray-800">
        {title || post.authorName}
      </p>
      <p className="flex flex-wrap items-center gap-1.5 text-xs text-gray-400">
        <span>{timeAgo(post.createdAt)}</span>
        {post.audienceName && (
          <>
            <span>&middot;</span>
            <span
              title={audienceChipTitle(post)}
              className={restricted ? RESTRICTED_CHIP_CLASS : AUDIENCE_CHIP_CLASS}
            >
              {restricted && <span aria-hidden="true">&#128274;</span>}
              {audienceChipLabel(post)}
            </span>
          </>
        )}
      </p>
    </div>

    <span className={badgeClass}>{badgeLabel}</span>
  </div>
  );
};

export default PostHeader;
